import { render, staticRenderFns } from "./home-swiper.vue?vue&type=template&id=70687212&scoped=true"
import script from "./home-swiper.vue?vue&type=script&lang=js"
export * from "./home-swiper.vue?vue&type=script&lang=js"
import style0 from "./home-swiper.vue?vue&type=style&index=0&id=70687212&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70687212",
  null
  
)

export default component.exports